module.exports = __webpack_public_path__ + "img/qiancai-back-people.fdf056a0.png";